
export default {
  props: {
    classProp: {
      type: String,
      default: "back-button-full-height"
    }
  }
};
